import { render, staticRenderFns } from "./product-description-head.vue?vue&type=template&id=4dec3ada"
import script from "./product-description-head.vue?vue&type=script&lang=js"
export * from "./product-description-head.vue?vue&type=script&lang=js"
import style0 from "./product-description.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports